<div class="flex flex-col gap-4">
  <mat-card>
    <mat-card-header class="flex justify-between">
      <mat-card-title>Apps</mat-card-title>
      <mat-card-subtitle
        >Create Apps to Manage your Integration</mat-card-subtitle
      >

      <div class="flex items-end justify-center gap-2 pb-4">
        <button mat-flat-button color="primary" (click)="addNewApp()">
          <mat-icon>add</mat-icon>
          Add New App
        </button>
      </div>
    </mat-card-header>
    <mat-card-content>
      <mat-nav-list>
        @if (apps$ | async; as apps) {
          @if (apps.length === 0) {
            <pr-empty-state
              type="text"
              explicitTitle="Add an App to get started"
            />
          } @else {
            @for (app of apps; track app.ref.path) {
              <mat-list-item>
                <a matListItemTitle [routerLink]="['./', 'apps', app.ref.id]">{{
                  app.name
                }}</a>

                <div matListItemLine class="mat-caption text-sm">
                  Created:
                  {{ app.createdAt | moment | amDateFormat: dateFormat }}
                </div>

                <div matListItemMeta>
                  <div class="flex items-center">
                    <button mat-icon-button [matMenuTriggerFor]="moreMenu">
                      <mat-icon>more_vert</mat-icon>
                    </button>

                    <mat-menu #moreMenu="matMenu">
                      <ng-template matMenuContent>
                        <button mat-menu-item (click)="editApp(app)">
                          <mat-icon color="accent">edit</mat-icon>
                          <span>Edit Name</span>
                        </button>
                      </ng-template>
                    </mat-menu>
                  </div>
                </div>
              </mat-list-item>
            }
          }
        }
      </mat-nav-list>
    </mat-card-content>
  </mat-card>
</div>
